import { FC } from 'react';
import Link from 'next/link';
import styles from './BtnsReviewQuote.module.scss';

interface IBtnsReviewQuote {
  reviewLink: string;
  extraClassName?: string;
}

const BtnsReviewQuote: FC<IBtnsReviewQuote> = ({ reviewLink, extraClassName }) => {
  const getBtnsClassNames = () => (extraClassName ? `${styles.btnsReviewQuote} ${styles[`${extraClassName}`]}` : styles.btnsReviewQuote);

  return (
    <div className={getBtnsClassNames()}>
      <Link prefetch={false} href={reviewLink} className={`${styles.btnsReviewQuote__item}`}>
        Добавить отзыв
      </Link>
    </div>
  );
};

export default BtnsReviewQuote;
